<template lang="pug">
  .user__item
    p.user__info.user__name(
      v-text="user.displayName"
    )
    p.user__info.user__email(
      v-text="user.email"
    )
    .user-roles__wrapper
      roles-list(
        :allRoles="user.roles"
        :appName="appName"
        :sub="user.sub || user.integerId"
        :availableRoles="availableRoles"
      )
      .button__delete(
        @click="deleteRoles"
      )
        include ../assets/svg/trash.svg
</template>

<script>
import RolesList from './RolesList.vue';
import { REMOVE_USER_FROM_APP } from '../constants';

export default {
  name: 'TheUser',

  components: {
    RolesList,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },

    appName: {
      type: String,
      required: true,
    },

    availableRoles: {
      type: Array,
      required: true,
    },
  },

  methods: {
    deleteRoles() {
      this.$store.dispatch(
        REMOVE_USER_FROM_APP,
        {
          userId: this.user.sub || this.user.integerId,
          appName: this.appName,
          roles: this.user.roles[this.appName],
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .user__item {
    display: flex;
    flex-direction: row;
    padding-top: 18px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;

    @include mobile {
      min-height: 91px;
      flex-direction: column;
      padding-top: 15px;
      padding-bottom: 6px;
      align-items: flex-start;
    }
  }

  .button__delete {
    cursor: pointer;
    margin-left: auto;

    svg {
      margin-top: 4px;
      fill: black;

      @include mobile {
        margin-top: 3px;
      }

      .trash-icon__path {
        fill: #9E9E9E;

      }
    }

    @include hover {
      svg .trash-icon__path {
        fill: black;
      }
    }
  }

  .user__email {
    margin-left: 40px;


    @include mobile {
      margin-left: 0;
    }
  }

  .user__info {
    width: 244px;
    min-width: 244px;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.31;
    letter-spacing: normal;
    color: #000000;
    text-overflow: ellipsis;
    overflow: hidden;

    @include mobile {
      min-width: 100%;
      font-size: 14px;
      line-height: 1.29;
    }
  }

  .user-roles__wrapper {
    display: flex;
    margin-left: 60px;
    flex-shrink: 2;
    max-width: 560px;
    width: calc(100% - 488px);

    @include mobile {
      min-width: 100%;
      width: 100%;
      margin-left: 0;
    }
  }

  .user__name {
    margin-bottom: 5px;
  }

  .user__email {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TheUser.vue